import React from 'react'
import {Field} from "react-final-form";

// resources
import { narrowDown } from '~/data/shop/itemSearchOption'

// components
import RenderRadioButton from '~/components/finalForms/atoms/RenderRadioButton'
import {css} from "@emotion/react";

export const PackingStyleField = React.memo(( ) => {
  return(
      <div>
        <div>
          <Field
              id="packingStyle"
              name="packingStyle"
              labels={narrowDown.packingStyle.map((category) => category.label)}
              vals={narrowDown.packingStyle.map((category) => category.code)}
              component={RenderRadioButton}
              row='true'
          />
        </div>
      </div>
  )
})

PackingStyleField.displayName = 'PackingStyleField'

const style = css`
  .radioBtn {
    display: none;
  }
`